import {NavLink} from "react-router-dom";
import {useTranslation} from "react-i18next";
import SubscriptionLockIcon from "./SubscriptionLockIcon.jsx";
import AdministratorOnlyIcon from "./AdministratorOnlyIcon.jsx";
import {isAdministratorOnlyRoute} from "../../../utils/routeAccess.js";

function SideBarLinkDesign({icon, name, isCurrent, locked, administratorOnly}) {
    const {t} = useTranslation();
    const administratorOnlyLabel = t("route.administrator_only", {defaultValue: "Pouze pro administrátory"});

    return <div
        className={`block truncate transition duration-150 ${
            isCurrent ? '!text-gray-800 dark:!text-white' : '!text-gray-800 hover:!text-violet-500 dark:!text-white dark:hover:!text-violet-400'
        }`}
    >
        <div className="ico-text flex items-center">
            <div className='icon w-5 text-center text-gray-400'>{icon}</div>
            <span
                className="text-sm font-medium ml-2 lg:hidden lg:sidebar-expanded:inline 2xl:inline"
            >
                {name}
                {locked && <span className="ml-1.5 inline-flex"><SubscriptionLockIcon/></span>}
                {administratorOnly && <span
                    className="ml-1.5 inline-flex text-violet-500"
                    title={administratorOnlyLabel}
                    aria-label={administratorOnlyLabel}
                ><AdministratorOnlyIcon/></span>}
            </span>
        </div>
    </div>;
}

export default function SidebarLinkStandalone({route, onLockedClick}) {
    let current = route['is_current'];
    let administratorOnly = isAdministratorOnlyRoute(route);

    if (route['name'] === null) {
        return <li></li>;
    }

    return <li
        className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${current && 'group-active standalone bg-violet-500/10 dark:bg-violet-500/20'}`}>
        {route['path'] && (route.lockedBySubscription
            ? <button type="button" className="w-full text-left" onClick={() => onLockedClick(route)}>
                <SideBarLinkDesign name={route['name']} icon={route['icon']} isCurrent={current} locked administratorOnly={administratorOnly}/>
            </button>
            : <NavLink end to={route['path']}>
                <SideBarLinkDesign name={route['name']} icon={route['icon']} isCurrent={current} administratorOnly={administratorOnly}/>
            </NavLink>)}
        {route['href'] && <a  target={'_blank'} href={route['href']}>
            <SideBarLinkDesign name={route['name']} icon={route['icon']} isCurrent={current} administratorOnly={administratorOnly}/>
        </a>}
    </li>;
}
